if (!customElements.get('eyam-build-trio')) {
  customElements.define('eyam-build-trio', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.variants = JSON.parse(this.querySelector('[data-trio-variants]').textContent);
      this.text = JSON.parse(this.querySelector('[data-trio-text]').textContent);
      this.choices = [...this.querySelectorAll('[data-choice]')];
      this.names = [...this.querySelectorAll('[data-name]')];
      this.toggle = this.querySelector('[data-engrave]');
      this.same = this.querySelector('[data-same]');
      this.button = this.querySelector('[data-add]');
      this.error = this.querySelector('[data-error]');
      this.form = this.querySelector('form');
      this.choices.forEach((select, i) => select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        const photo = this.querySelectorAll('[data-photo]')[i];
        const empty = this.querySelectorAll('[data-empty]')[i];
        photo.hidden = !select.value;
        empty.hidden = !!select.value;
        if (select.value) { photo.src = option.dataset.image; photo.alt = option.dataset.title; }
        select.closest('.ebt-bottle').querySelectorAll('[data-scent-option]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.scentOption === select.value)));
        this.error.textContent = '';
        this.update();
      }));
      this.querySelectorAll('[data-scent-option]').forEach(button => button.addEventListener('click', () => {
        const select = button.closest('.ebt-bottle').querySelector('[data-choice]');
        select.value = button.dataset.scentOption;
        select.dispatchEvent(new Event('change', {bubbles:true}));
        button.closest('details').open = false;
        select.focus();
      }));
      this.toggle.addEventListener('change', () => this.updateNames());
      this.same.addEventListener('change', () => this.updateNames());
      this.names.forEach(input => input.addEventListener('input', () => { this.error.textContent = ''; this.updateNames(); }));
      this.form.addEventListener('submit', event => this.submit(event));
      this.choices.forEach(select => select.dispatchEvent(new Event('change')));
      this.updateNames();
      this.update();
    }
    selectedVariant() {
      if (this.choices.some(select => !select.value)) return null;
      const key = this.choices.map(select => select.value).sort().map(code => [...this.choices[0].options].find(option => option.value === code).dataset.title).join(' + ');
      return this.variants.find(variant => variant.key === key && variant.price === 10000 && variant.available);
    }
    update() {
      const complete = this.choices.every(select => !!select.value);
      this.button.disabled = this.busy || !this.selectedVariant();
      this.querySelector('[data-summary]').textContent = complete ? (this.selectedVariant() ? this.text.ready : this.text.unavailable) : this.text.choose;
    }
    updateNames() {
      this.toggle.setAttribute('aria-expanded', String(this.toggle.checked));
      this.querySelector('[data-same-wrap]').hidden = !this.toggle.checked;
      this.names.forEach((input, index) => {
        input.closest('[data-name-field]').hidden = !this.toggle.checked;
        input.disabled = !this.toggle.checked;
        input.readOnly = this.same.checked && index > 0;
        if (this.same.checked && index > 0) input.value = this.names[0].value;
        input.required = this.toggle.checked;
      });
    }
    async submit(event) {
      event.preventDefault();
      if (this.busy) return;
      this.updateNames();
      const variant = this.selectedVariant();
      if (!variant) { this.error.textContent = this.text.unavailable; return; }
      if (this.toggle.checked) {
        const empty = this.names.find(input => !input.value.trim());
        if (empty) { this.error.textContent = this.text.name; empty.focus(); return; }
      }
      if (!this.form.reportValidity()) return;
      const properties = {};
      this.choices.forEach((select, i) => {
        properties['Bottle ' + (i + 1)] = select.selectedOptions[0].dataset.title;
        if (this.toggle.checked) properties['Bottle ' + (i + 1) + ' - Name to Engrave'] = this.names[i].value.trim();
      });
      if (this.toggle.checked) properties['Add Free Name Engraving'] = 'Yes';
      this.busy = true;
      this.error.textContent = '';
      this.button.textContent = this.text.adding;
      this.update();
      try {
        const response = await fetch(this.dataset.root + 'cart/add.js', {
          method: 'POST', headers: {'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({items:[{id:variant.id,quantity:1,properties}]})
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || this.text.error);
        window.location.assign(this.dataset.cart);
      } catch (error) {
        this.error.textContent = error.message || this.text.error;
        this.busy = false;
        this.button.textContent = this.text.add;
        this.update();
      }
    }
  });
}
